import { GraduationCap, Mail, MessageCircle } from "lucide-react";
import { CONTACT } from "./site";

export const Footer = () => (
    <footer className="border-t border-ground-line/60 bg-ground-deep" data-testid="footer">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-6 py-12 sm:flex-row sm:items-center">
            <div>
                <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-sun text-ground-deep">
                        <GraduationCap className="h-5 w-5" strokeWidth={2.2} />
                    </span>
                    <span className="font-heading text-lg font-extrabold text-ink">
                        YNova <span className="text-sun">Education</span>
                    </span>
                </div>
                <p className="font-heading mt-2 text-sm font-bold text-sun">Better English. Brighter Future.</p>
                <p className="mt-2 text-sm text-mist">
                    Online English tutoring for children in Grades 1–6 • South Africa • United Kingdom • United States
                </p>
            </div>
            <div className="flex flex-col gap-3 text-sm">
                <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="flex items-center gap-2 text-mist transition-colors hover:text-sun">
                    <Mail className="h-4 w-4 text-sun" /> {CONTACT.email}
                </a>
                <a href={CONTACT.whatsappUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-2 text-mist transition-colors hover:text-sun">
                    <MessageCircle className="h-4 w-4 text-sun" /> {CONTACT.phoneDisplay}
                </a>
            </div>
        </div>
        <div className="border-t border-ground-line/40">
            <p className="mx-auto max-w-7xl px-6 py-5 text-xs text-mist/60">
                © {new Date().getFullYear()} YNova Education. All rights reserved.
            </p>
        </div>
    </footer>
);
